import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: "sps-workflow-step, sps-wf-step",
    templateUrl: "./sps-workflow-step.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsWorkflowStepComponent {
    static readonly displayName = "sps-workflow-step, sps-wf-step";
    static readonly props = {
        title: "string",
        icon: "string",
    };

    @HostBinding("class.sps-workflow__step") readonly _spsWorkflowStepClass = true;

    @Input() icon: string;
    @Input() title: string;
}
